import { render, staticRenderFns } from "./WideNav.vue?vue&type=template&id=95470766&scoped=true&"
import script from "./WideNav.vue?vue&type=script&lang=js&"
export * from "./WideNav.vue?vue&type=script&lang=js&"
import style0 from "./WideNav.vue?vue&type=style&index=0&id=95470766&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95470766",
  null
  
)

export default component.exports